import Menu from "./menu.js";

// on document ready
const domReady = () => {
    const docHTML = document.querySelector('html');

    // Setup
    document.querySelector('body').classList.remove('no-js');
    document.querySelector('body').classList.add('js-ready');

    // Init Main menu - separate file for clarity
    new Menu();

    // external links
    const links = document.querySelectorAll('a');
    links.forEach(el => {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(el.href)) {
            el.setAttribute('target', '_blank');
            el.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                window.open(e.target.href, '_blank');
            }, this);
        }
    });

    const tutor_payment_options = document.querySelector('.tutor-checkout-payment-options');
    if(tutor_payment_options) {
        const hidden_input = tutor_payment_options.querySelector('input[name="payment_type"]');
        const first_option = tutor_payment_options.querySelector('.tutor-checkout-payment-item');
        hidden_input.setAttribute('value', first_option.getAttribute('data-payment-type'));
        first_option.classList.add('active');
    }
}

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    domReady();
} else {
    document.addEventListener("DOMContentLoaded", domReady);
}